<div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
  <div class="flex flex-col gap-2">
    <span class="ds-body-2">Rollen</span>
    <soft-ds-item-group class="border rounded-md overflow-hidden" [separators]="false">
      @for (role of roles(); track role.role) {
      <soft-ds-item
        [interactive]="true"
        [variant]="isSelected(role) ? 'muted' : 'default'"
        (activate)="selectRole(role)"
      >
        <soft-ds-item-leading>
          <soft-ds-icon name="fa-regular fa-shield" />
        </soft-ds-item-leading>
        <soft-ds-item-title>
          {{ 'WORKFLOW.ROLE.'+role.role | translate }}
        </soft-ds-item-title>
      </soft-ds-item>
      }@empty {
      <span class="py-3 px-6">Keine Rollen.</span>
      }
    </soft-ds-item-group>
  </div>

  <div class="flex flex-col gap-2">
    <span class="ds-body-2">Benutzer/Gruppen</span>
    <div class="flex gap-1 items-start">
      <soft-ds-item-group class="border rounded-md overflow-hidden" [separators]="false">
        @for (participant of filteredParticipants(); track participant.id) {
        <soft-ds-item class="group" variant="default">
          <soft-ds-item-leading>
            <soft-ds-icon
              [name]="participant.isGroup ? 'fa-regular fa-users' : 'fa-regular fa-user'"
            />
          </soft-ds-item-leading>
          <soft-ds-item-title>{{ participant.name }}</soft-ds-item-title>
          <soft-ds-item-trailing>
            <soft-ds-button
              variant="ghost"
              mode="iconOnly"
              size="sm"
              class="opacity-0 group-hover:opacity-100 transition-opacity"
              softToolTip="Teilnehmer entfernen"
              aria-label="Teilnehmer entfernen"
              (click)="onDeleteClick(participant)"
            >
              <soft-icon
                *softSlot="'leading'"
                name="fa-regular fa-trash"
                color="danger"
              />
            </soft-ds-button>
          </soft-ds-item-trailing>
        </soft-ds-item>
        }@empty {
        <span class="py-3 px-6">Keine Benutzer.</span>
        }
      </soft-ds-item-group>

      <div class="flex flex-col gap-1">
        <soft-ds-button
          variant="outline"
          mode="iconOnly"
          (click)="onAddClick(false)"
          softToolTip="Teilnehmer hinzufügen"
        >
          <soft-icon *softSlot="'leading'" name="fa-regular fa-user-plus" />
        </soft-ds-button>
        <soft-ds-button
          variant="outline"
          mode="iconOnly"
          (click)="onAddClick(true)"
          softToolTip="Gruppe hinzufügen"
        >
          <soft-icon *softSlot="'leading'" name="fa-regular fa-users" />
        </soft-ds-button>
      </div>
    </div>
  </div>
</div>
